<div class="fixed z-[9999] inset-0 w-dvw h-dvh">
  <!-- Overlay -->
  <div
    (click)="handleOverlayClick($event)"
    class="size-full fixed inset-0 z-40 bg-black opacity-40"
  ></div>

  <!-- Modal -->
   <div class="size-fit max-h-full max-w-7xl max-sm:w-[95%] overflow-auto fixed z-50 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
     <div
       data-aos="fade-down"
       data-aos-delay="100"
       data-aos-offset="-300"
       
     >
       <div
         class="p-7 rounded-2xl bg-white"
         [class]="class"
         [ngStyle]="ngStyle"
       >
         <ng-content></ng-content>
       </div>
     </div>
   </div>
</div>
